import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'shared-ui-control-switch',
  imports: [CommonModule],
  templateUrl: './control-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ControlSwitchComponent),
      multi: true,
    },
  ],
})
export class ControlSwitchComponent implements ControlValueAccessor {
  readonly id = input('shared-ui-control-switch');
  readonly label = input('');

  protected readonly checked = signal(false);
  protected readonly disabled = signal(false);

  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: boolean | null): void {
    this.checked.set(value === true);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  protected toggle(): void {
    if (this.disabled()) return;

    const nextValue = !this.checked();
    this.checked.set(nextValue);
    this.onChange(nextValue);
    this.onTouched();
  }

  protected toggleWithKeyboard(event: Event): void {
    event.preventDefault();
    this.toggle();
  }

  protected markAsTouched(): void {
    this.onTouched();
  }
}
